/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import ko from 'knockout';
import template from '@bingads-webui-static-legacy/bulk-edit/template/demographics/changeCashbackPercent.pug';
import viewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/changeCashbackPercent';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import numericActionType from '@bingads-webui-static-legacy/schema/bulkEdit/numericActionType';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
import filterConverter from '@bingads-webui-static-legacy/odata-filter-converter';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var formatEntityString = function (entityKeyObject) {
  var name = '';
  if (entityKeyObject.hasOwnProperty('AgeRange')) {
    var ageRangeEnum = entityKeyObject.AgeRange;
    name = i18n.getString('Schema_Enum_AgeRange_' + ageRangeEnum);
  } else if (entityKeyObject.hasOwnProperty('GenderType')) {
    var genderTypeEnum = entityKeyObject.GenderType;
    name = genderTypeEnum;
  } else if (entityKeyObject.hasOwnProperty('ProfileType')) {
    var profileName = entityKeyObject.ProfileName;
    name = profileName;
  }
  return name;
};
var formatBid = function (rows) {
  if (rows) {
    _.each(rows, function (value) {
      value.data = [];
      value.EntityKeyObject = {};
      _.each(value.EntityKey, function (obj) {
        value.EntityKeyObject[obj.Key] = obj.Value;
      });
      value.data.push({
        value: value.EntityKeyObject.CampaignName,
        isHtml: false
      });
      value.data.push({
        value: value.EntityKeyObject.AdgroupName,
        isHtml: false
      });
      var name = formatEntityString(value.EntityKeyObject);
      value.data.push({
        value: name,
        isHtml: false
      });
      if (value.Changes && value.Changes.length) {
        var originalValue = value.Changes[0].OriginalValue;
        value.data.push({
          value: originalValue === '' || +originalValue === -1 ? i18n.getString('Campaign_Cashback_Offer_Scope_InheritFromParent') : decimalNumber.fromFloatToPercentString(value.Changes[0].OriginalValue, 2),
          isHtml: false
        });
        var newValue = value.Changes[0].NewValue;
        var newValueText;
        if (+newValue === -1 || newValue === '') {
          newValueText = i18n.getString('Campaign_Cashback_Offer_Scope_InheritFromParent');
        } else {
          newValueText = decimalNumber.fromFloatToPercentString(value.Changes[0].NewValue, 2);
        }
        value.data.push({
          value: newValueText,
          isHtml: false
        });
      } else {
        value.data.push({
          value: '',
          isHtml: false
        });
        value.data.push({
          value: '',
          isHtml: false
        });
      }
    });
  }
  return rows;
};
var getSelectedEntityIdStrings = function (gridView) {
  return _.map(gridView.selectedItems(), function (obj) {
    var campaignId = obj.Campaign ? obj.Campaign.Id : $.advertiser.getUrlParameter('cmpid');
    return _.compact(['CampaignId=' + campaignId, obj.AdGroup && 'AdGroupId=' + obj.AdGroup.Id, 'TargetGroupDetailId=' + obj.Id]).join(',');
  });
};
var view = BaseView.extend({
  initialize: function (options) {
    this.options = options || ({});
    BaseView.prototype.initialize.apply(this, arguments);
    this.template = template;
    this.entity = options.entity;
    this.ko_model = new viewModel({});
    _.extend(this, options);
  },
  render: function () {
    BaseView.prototype.render.apply(this, arguments);
    return this;
  },
  setAction: function (simulateResults) {
    var action = null;
    this.model.unset('PreviewEntityIds');
    this.model.unset('PreviewCompositeIds');
    if (simulateResults) {
      if (this.grid.pgridPlugins.crossPageSelectAll.isAllSelected) {
        this.model.set('PreviewCompositeIds', getSelectedEntityIdStrings(this.grid.gridView));
      }
    }
    var cashbackPercentValue = this.ko_model.getCashbackPercentValueByAction();
    action = {
      Actions: [{
        '@odata.type': '#Model.NumericAction',
        Property: 'CashbackAdjustment',
        ActionType: numericActionType.setAmount,
        Value: cashbackPercentValue
      }]
    };
    this.model.set('BatchAction', action);
  },
  getIdFilter: function () {
    return {
      FilterExpressions: [{
        SelectedColumn: 'IdString',
        SelectedOperator: 'Equal',
        Values: getSelectedEntityIdStrings(this.grid.gridView)
      }]
    };
  },
  getFilterURLParam: function (filter, entity) {
    var conditionString = this.grid.filterService.getCombinedFilter().odataV4();
    var result;
    if (filter.idBased) {
      var idFilterExperessions = _.filter(filter.FilterExpressions, function (filterExpression) {
        return filterExpression.SelectedColumn === 'IdString';
      });
      var idString = filterConverter.convert(idFilterExperessions, entity).$filter;
      var criterionTypeConditionRegex = /isof\(Criterion, 'Model.[\w]+Criterion'\)/;
      var conditionFragment = conditionString.match(criterionTypeConditionRegex)[0];
      result = conditionFragment + ' and ' + idString;
    } else {
      result = conditionString;
    }
    return '$filter=(' + encodeURIComponent(result) + ')';
  },
  formatErrors: function (errors) {
    return formatBid(errors);
  },
  formatPreviewResults: function (results) {
    return formatBid(results);
  },
  getProgressText: function () {
    return i18n.getString('BulkEdit_Campaigns_ProgressText');
  }
});
export default view;

